import { DimensionOrientationMode } from '@r-core/types';
import { DisplayMode } from '@r-core';
import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const dimensionOrientationSubmenuMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.SubMenu,
		label: 'Dimension Orientation',
		displayModes: [DisplayMode.Overhead, DisplayMode.OverheadManufacturing, DisplayMode.SkuOverhead, DisplayMode.SkuOverheadManufacturing],
		isVisible: ({ controller }): boolean => {
			return !controller.readonly;
		},
		items: [
			{
				type: ContextMenuListItemType.Item,
				content: 'Standard',
				onClick: ({ controller }): void => {
					controller.options.dimensionOrientationMode = DimensionOrientationMode.Standard;
				}
			},
			{
				type: ContextMenuListItemType.Item,
				content: 'Level',
				onClick: ({ controller }): void => {
					controller.options.dimensionOrientationMode = DimensionOrientationMode.Level;
				}
			}
		]
	};
};
